import { z, ZodSchema } from 'zod/v4';
import { Brand } from '../branded-types';

export type LayoutId = Brand<string, 'layoutId'>;

export const LAYOUT_SCHEMA: ZodSchema = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as LayoutId)
    .nullable(),
  layoutName: z.string(),
  xmlValue: z.string(),
  uploadedAt: z.coerce.date(),
});

export const LAYOUTS_SCHEMA: ZodSchema = z.array(LAYOUT_SCHEMA);

export interface ILayout {
  id?: LayoutId;
  layoutName: string;
  xmlValue: string;
  uploadedAt: Date;
}
